import { Component } from 'react'
import { StatePanel } from './StatePanel'
import { Button } from './Button'
import styles from './ErrorBoundary.module.css'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <StatePanel
          state="error"
          title="Something went wrong"
          description={this.state.error?.message || 'An unexpected error occurred'}
          action={(
            <div className={styles.actions}>
              <Button
                variant="secondary"
                onClick={() => this.setState({ hasError: false, error: null })}
              >
                Try Again
              </Button>
              <Button onClick={() => window.location.reload()}>
                Reload
              </Button>
            </div>
          )}
        />
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
